import React, { Fragment } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { path } from 'ramda';

const propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  error: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  name: PropTypes.string,
  status: PropTypes.object,
  onClick: PropTypes.func,
  tip: PropTypes.any,
};

const Checkbox = ({ checked, className, error, label, name, onBlur, onChange, status, tip }) => {
  const id = `custom-check-${name}`;
  const errorMsg = path(['errors', name], status) || error;

  return (
    <Fragment>
      <div className={cn(className, 'custom-control custom-checkbox')}>
        <input
          type="checkbox"
          className="custom-control-input"
          id={id}
          name={name}
          checked={!!checked}
          onBlur={onBlur}
          onChange={onChange}
        />
        <label className="custom-control-label" htmlFor={id}>
          {label}
        </label>
        {errorMsg && (
          <span className="invalid-feedback block-fix">
            <strong>{errorMsg}</strong>
          </span>
        )}
      </div>
      {tip && <div className="tip pl-4 mt-n">{tip}</div>}
    </Fragment>
  );
};

Checkbox.propTypes = propTypes;

export default Checkbox;
